import React, { useEffect } from "react";
import { configureFlickity, enableFlickity } from "../public/js/core";
import { useScripts } from "../services/hooks/useScripts";

const ProductImageSlider = React.memo(({ product, isInStock, isOnSale }) => {
  const { loadScripts, scriptsLoadStatus } = useScripts({
    async: false,
  });

  useEffect(() => {
    loadScripts([
      "/libs/@fancyapps/fancybox/dist/jquery.fancybox.min.js",
      "/libs/flickity/dist/flickity.pkgd.min.js",
      "/libs/flickity-fade/flickity-fade.js",
    ]);
  }, []);

  useEffect(() => {
    if (scriptsLoadStatus === "ready") {
      configureFlickity();

      enableFlickity("#product-slider", {
        draggable: false,
        fade: true,
        imagesLoaded: true,
      });

      enableFlickity("#product-slider-nav", {
        asNavFor: "#product-slider",
        contain: true,
        wrapAround: false,
      });
    }
  }, [scriptsLoadStatus]);

  return (
    <div className="col-12 col-md-6">
      {/* Card */}
      <div className="card">
        {/* Badge */}
        {/* {isOnSale && (
          <div className="badge badge-dark card-badge text-uppercase">
            Member Pricing
          </div>
        )} */}

        {/* Slider */}
        <div className="mb-4" id="product-slider">
          {product?.images.map((image) => (
            <a key={image.id} href={image.src} data-fancybox>
              <img
                src={image.src}
                alt={product?.name}
                className="card-img-top"
                style={{ height: "31.25rem" }}
              />
            </a>
          ))}
        </div>
      </div>
      {/* Slider */}
      <div className="flickity-nav mx-n2 mb-10 mb-md-0" id="product-slider-nav">
        {product?.images.map((image) => (
          <div key={image.id} className="col-12 px-2" style={{ maxWidth: 113 }}>
            {/* Image */}
            <div
              className="embed-responsive embed-responsive-1by1 bg-cover"
              style={{
                backgroundImage: `url(${image.src})`,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default ProductImageSlider;
